module.exports = __webpack_public_path__ + "static/media/yeoman.83c46c72.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/yeoman.png
// module id = 219
// module chunks = 0